module.exports = __webpack_public_path__ + "static/img/produto_p.0ee8cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_guarana/produto_p.png
// module id = vctN
// module chunks = 0